// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const TemplateIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="TemplateIcon" ref={forwardedRef} {...props}>
      <path d="M4 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h4.5a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm.5 1.5H8v11H4.5z" />
      <path d="M12 3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm.5 1.5h3v5h-3z" />
      <path d="M11 13.44a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1V16a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zm1.5 2.06h3v-1.56h-3z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const TemplateIcon = /* @__PURE__ */ Object.assign(
  TemplateIconComponent,
  { displayName: 'TemplateIcon' },
);
